<template>
  <div v-if="statement" class="flex gap-x-4">
    <InputField
      v-model="statement.data.from"
      type="number"
      :label="$t('logicStatement.numberRange.from')"
      :placeholder="$t('logicStatement.numberRange.from')"
      :error="errors?.from"
      :disabled="disabled"
      class="my-4 w-1/2"
    />
    <InputField
      v-model="statement.data.to"
      type="number"
      :label="$t('logicStatement.numberRange.to')"
      :placeholder="$t('logicStatement.numberRange.to')"
      :error="errors?.to"
      :disabled="disabled"
      class="my-4 w-1/2"
    />
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import InputField from '@utils/inputs/Input.vue';
import type { FilterPrototype, LogicStatement, MaybeHydra } from '@/entities/Entities';

interface Props {
  modelValue?: MaybeHydra<
    LogicStatement<{
        from: number;
        to: number;
    }>
  >;
  prototype: FilterPrototype<{ from: string, to: string }, Record<string, never>>;
  errors?: object;
  disabled?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);
const statement = useVModel(props, 'modelValue', emit, { passive: true });
</script>

<style lang="scss" scoped></style>
